const panelMobileCollapse = () => {
	$('.panel__head').on('click', function() {
		const $this = $(this);

		if ($(window).innerWidth() > 767) {
			return;
		}

		$this.closest('.panel')
			.toggleClass('is-current')
			.closest('.panels__item')
			.siblings()
			.find('.panel')
			.removeClass('is-current')
			.find('.panel__body')
			.slideUp();

		$this.siblings('.panel__body').slideToggle();
	});
}

panelMobileCollapse();
